export const CheckMarkIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="11" height="11" rx="5.5" fill="#1478B4"/>
  <path d="M8.625 4.3125L5.0956 8.0625L3.375 6.375" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="0.5" y="0.5" width="11" height="11" rx="5.5" stroke="#1478B4"/>
  </svg>
   
);
